import { api } from '../../core/api.js';

function idPath(id) {
  return `/schedules/${encodeURIComponent(id)}`;
}

export function listSchedules(productId) {
  return api(`/schedules?product_id=${encodeURIComponent(productId)}`);
}

export function saveSchedule(id, body) {
  if (id) return api(idPath(id), { method: 'PUT', body });
  return api('/schedules', { method: 'POST', body });
}

export function runSchedule(id) {
  return api(`${idPath(id)}/run`, { method: 'POST', body: {} });
}

export function setEnabled(id, enabled) {
  return api(idPath(id), { method: 'PUT', body: { enabled: !!enabled } });
}

export function removeSchedule(id) {
  return api(idPath(id), { method: 'DELETE' });
}
